const rollups = document.querySelectorAll(".rollup");

rollups.forEach(rollupElement => {
  rollupElement.addEventListener("mouseenter", rollup)
})
function rollup(e) {
  console.log(e)
}
